function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "myAddresses_svg__a"
}, React.createElement("path", {
  d: "M1 0h18v20H1zm0 0"
})), React.createElement("clipPath", {
  id: "myAddresses_svg__b"
}, React.createElement("path", {
  d: "M9.863 16.066V20h.985v-3.934h1.312V20h.98v-3.934h5.247V8.523a3.934 3.934 0 00-3.934-3.933h-2.621V3.277h2.95V0h-3.934v4.59H5.602a3.934 3.934 0 00-3.934 3.933v7.543zm3.934-13.77h-1.965V.985h1.965zm-2.95 3.278v3.117a.818.818 0 00-.284.914c.109.336.421.563.777.563a.822.822 0 00.492-1.477V5.574h2.621a2.952 2.952 0 012.953 2.95v6.558h-7.87V8.523a3.931 3.931 0 00-1.337-2.949zm-8.199 9.508V8.523a2.952 2.952 0 012.954-2.949 2.95 2.95 0 012.949 2.95v6.558zm0 0"
})), React.createElement("clipPath", {
  id: "myAddresses_svg__c"
}, React.createElement("path", {
  d: "M3.633 9.18h3.933v.984H3.633zm0 0"
})));

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  d: "M0 0h20v20H0z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#myAddresses_svg__a)"
}, React.createElement("g", {
  clipPath: "url(#myAddresses_svg__b)"
}, React.createElement("path", {
  d: "M0 0h20v20H0z"
})));

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#myAddresses_svg__c)"
}, React.createElement("path", {
  d: "M-1.367 4.18h13.933v10.984H-1.367zm0 0"
}));

var SvgMyAddresses = function SvgMyAddresses(props) {
  return React.createElement("svg", _extends({
    width: "20pt",
    height: "20pt",
    viewBox: "0 0 20 20"
  }, props), _ref, _ref2, _ref3, _ref4);
};

export default SvgMyAddresses;